import { dataAbTest } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAbTest = /*#__PURE__*/createIcon(dataAbTest)
export default IconAbTest
